import { useEffect, useState } from "react";
import { getToken } from "../utility/Constant";
const useSession = () => {
  const [user, setUser] = useState([]);
  const [loading, setLoading] = useState(true);
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getToken(),
    },
  };
  const url = `${process.env.REACT_APP_API_URL}/user/me`;

  useEffect(() => {
    fetch(url, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        setUser(data.data);
        setLoading(false);
      });
  }, []);
  return [user, loading];
};

export default useSession;
